<template>
  <section id="caseStudies" class="py-24 bg-white dark:bg-dark-surface transition-colors duration-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16 max-w-3xl mx-auto">
        <h2 class="text-base font-semibold text-accent tracking-wide uppercase transition-colors duration-300">{{ t('caseStudies.subtitle') }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl transition-colors duration-300">{{ t('caseStudies.title') }}</p>
      </div>
      
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div v-for="(item, index) in tm('caseStudies.cases')" :key="index" class="animate-on-scroll group bg-gray-50 dark:bg-dark-surface rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-indigo-900/50">
          <div class="relative overflow-hidden h-48">
            <img :src="caseImages[index % caseImages.length]" :alt="t('images.cases.' + caseAlts[index % caseAlts.length])" class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          </div>
          <div class="p-8">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-accent/20 text-accent mb-6 transition-colors duration-300">
              {{ item.industry || t('caseStudies.labelIndustry') }}
            </span>
            <h3 class="text-2xl font-bold text-gray-900 dark:text-white mb-8 transition-colors duration-300">{{ item.title }}</h3>
            
            <div class="space-y-6">
              <div>
                <h4 class="text-sm font-bold text-primary dark:text-gray-300 uppercase tracking-wider mb-2 transition-colors duration-300">{{ t('caseStudies.labelChallenge') }}</h4>
                <p class="text-gray-600 dark:text-gray-400 text-sm leading-relaxed transition-colors duration-300">{{ item.challenge }}</p>
              </div>
              <div>
                <h4 class="text-sm font-bold text-primary dark:text-gray-300 uppercase tracking-wider mb-2 transition-colors duration-300">{{ t('caseStudies.labelSolution') }}</h4>
                <p class="text-gray-600 dark:text-gray-400 text-sm leading-relaxed transition-colors duration-300">{{ item.solution }}</p>
              </div>
              <div class="pt-4 border-t border-gray-200 dark:border-indigo-900/50 transition-colors duration-300">
                <h4 class="text-sm font-bold text-accent uppercase tracking-wider mb-2 transition-colors duration-300">{{ t('caseStudies.labelResult') }}</h4>
                <p class="text-gray-900 dark:text-white font-medium transition-colors duration-300">{{ item.result }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAnimateOnScroll } from '@/composables/useAnimateOnScroll'

const { t, tm } = useI18n({ useScope: 'global' })
const { observeElements } = useAnimateOnScroll(null, { animateClass: 'animate-in-left' })

const caseImages = [
  require('@/assets/img/stock/case-cloud-dashboard.jpg'),
  require('@/assets/img/stock/case-server-room.jpg'),
  require('@/assets/img/stock/case-team-collab.jpg'),
  require('@/assets/img/stock/case-code-screen.jpg')
]
const caseAlts = ['dashboard', 'serverRoom', 'teamCollab', 'codeScreen']

onMounted(() => {
  observeElements('.animate-on-scroll')
})
</script>
